import React from 'react';
import { Icon } from '../../../../ui-kit';








function DefaultThumbnail({
  defaultThumbnail,
  defaultThumbnailIconName = 'user',
  defaultThumbnailIconSize = '24',
  defaultThumbnailIconColor = 'nevada'
}) {
  return defaultThumbnail ||
  <Icon
    className="voice-over-preview____default-thumbnail--icon"
    name={defaultThumbnailIconName}
    size={defaultThumbnailIconSize}
    color={defaultThumbnailIconColor} />;


}

export default DefaultThumbnail;